/**
 * Rounds a number to a specified precision / number of decimal places.
 * Defaults to `4` decimal places (or `0.0001 m`)
 * @param value the number to be rounded
 * @param decimals the decimal precision
 * @returns
 */
function roundDecimals(value, decimals = 4) {
    const raised = Math.pow(10, decimals);
    return Math.round(value * raised) / raised;
}

export { roundDecimals };
//# sourceMappingURL=round-decimals.js.map
